import React, { useEffect, useState } from "react";
import HomeContainer from "./HomeContainer";
import { motion } from "framer-motion";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import RowContainer from "./RowContainer";
import MenuContainer from "./MenuContainer";
import CartContainer from "./CartContainer";
import { useDispatch, useSelector } from "react-redux";
import { getAllCartItems, getAllCategories, getAllProducts } from "../api";
import { setAllProducts } from "../context/actions/productAction";
import { setAllCategories } from "../context/actions/categoryActions";
import { setCartItems } from "../context/actions/cartActions";

const MainContainer = () => {
  const dispatch = useDispatch();
  const [scrollValue, setScrollValue] = useState(0);
  const cartItems = useSelector(state => state.cart);
  const cartShow = '';
  const newProducts = useSelector(state => state.products);

  useEffect(() => {
    getAllProducts().then((data) => {
      dispatch(setAllProducts(data));
    });
    getAllCategories().then(data => {
      dispatch(setAllCategories(data))
    })
    getAllCartItems().then(data => {
      dispatch(setCartItems(data))
    })
  }, [dispatch])

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center ">
      {cartItems && cartItems.length > 0 && (
        <motion.div
          initial={{ opacity: 0, x: 200 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 200 }}
          onClick
          whileTap={{ scale: 0.75 }}
          className="fixed w-10/12 rounded-md bg-red-400 border-b-4 border-red-600 h-10 bottom-5 z-10 flex justify-center items-center cursor-pointer">
          <p className="text-base text-white drop-shadow-2xl">Giỏ hàng hiện tại : {cartItems.length}</p>
        </motion.div>
      )}

      <HomeContainer />

      <section className="w-full my-6">
        <div className="w-full flex items-center justify-between">
          {/* <p className="text-2xl font-semibold capitalize text-headingColor relative before:absolute before:rounded-lg before:content before:w-32 before:h-1 before:-bottom-2 before:left-0 before:bg-gradient-to-tr from-orange-400 to-orange-600 transition-all ease-in-out duration-100">
            Món mới ra lò
          </p> */}

          {/* <div className="hidden md:flex gap-3 items-center">
            <motion.div
              whileTap={{ scale: 0.75 }}
              className="w-8 h-8 rounded-lg bg-orange-300 hover:bg-orange-500 cursor-pointer  hover:shadow-lg flex items-center justify-center"
              onClick={() => setScrollValue(-200)}
            >
              <MdChevronLeft className="text-lg text-white" />
            </motion.div>
            <motion.div
              whileTap={{ scale: 0.75 }}
              className="w-8 h-8 rounded-lg bg-orange-300 hover:bg-orange-500 cursor-pointer transition-all duration-100 ease-in-out hover:shadow-lg flex items-center justify-center"
              onClick={() => setScrollValue(200)}
            >
              <MdChevronRight className="text-lg text-white" />
            </motion.div>
          </div> */}
        </div>
        {/* <RowContainer
          scrollValue={scrollValue}
          flag={true}
          data={newProducts?.filter((n) => n.product_category === "Thức ăn")}
        /> */}

      </section>

      <MenuContainer />

      {cartShow && <CartContainer />}
    </div>
  );
};

export default MainContainer;